interface Ifoot {
  preparedBy: string | null | undefined;
  approvedBy: string | null | undefined;
}
const TFoot = ({ preparedBy, approvedBy }: Ifoot) => {
  return (
    <tfoot>
      <tr>
        <th colSpan={2}>Legends:</th>
        <th colSpan={1}>OK &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;O</th>
        <th colSpan={1}>NG &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;X</th>
        <th colSpan={2}>Under Deviation&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; △ </th>
        <th colSpan={6}></th>
      </tr>
      <tr>
        <th colSpan={5} align="left">
          Prepared By: {preparedBy}
        </th>
        <th colSpan={7} align="left">
          Approved By: {approvedBy}
        </th>
      </tr>
    </tfoot>
  );
};

export default TFoot;
